import { Typography } from '../primitives/index.js'
import { TreeItem, type TreeItemProps } from '../primitives/tree-view.js'
import { Page } from '@tunasong/icons'
import type { ColorName, Entity, Persisted } from '@tunasong/schemas'
import type { FC, Ref } from 'react'
import { getColorCSS, hashColorName } from '../color/index.js'

export interface EntityTreeItemProps extends Omit<TreeItemProps, 'itemId'> {
  color?: ColorName
  Icon?: FC
  entity: Persisted<Entity>
  open?: boolean
  /** Item is excluded from selection */
  excluded?: boolean
  ref?: Ref<unknown>
}

export const EntityTreeItem = (props: EntityTreeItemProps) => {
  const {
    entity,
    ref,
    Icon = Page,
    color = entity?.type ? hashColorName(entity?.type) : 'grey',
    excluded = false,
    ...other
  } = props

  if (!entity) {
    return null
  }

  /** @todo factor out getEntityLabel, etc.  */
  const labelText = entity?.name

  return (
    <TreeItem
      itemId={entity.id}
      label={
        <div
          ref={ref as React.Ref<HTMLDivElement>}
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '4px 0',
            opacity: excluded ? 0.5 : 1,
          }}
        >
          <Icon style={{ color: getColorCSS(color), padding: '0 4px 0 0' }} />
          <Typography variant="body2">{labelText}</Typography>
        </div>
      }
      {...other}
    />
  )
}
